import { createSelector } from 'reselect';
import { getFormValues } from 'redux-form';

import { filterByString } from '@topconagriculture/frontend-utils';

import { RootState } from '../../reducers';
import { Forms, SearchFormFields } from '../../form/form.selector';
import { trimWhitespace } from '../../../core/helpers/utils/utils';
import { Operator } from '../../../core/api/operator/operator.types';

export const getAllOperators = (state: RootState): Operator[] => state.entities.operators;

export const getOperators = createSelector(getAllOperators, (operators) =>
  operators.filter((operator) => !operator.deleted),
);

const operatorsFilterFormSelector = getFormValues(Forms.operatorsSearch) as () => SearchFormFields;

export const getOperatorsFiltered = createSelector(
  [getOperators, operatorsFilterFormSelector],
  (operatorsList: Operator[], filterFormValues: SearchFormFields): Operator[] => {
    return filterFormValues
      ? operatorsList.filter((operator) => {
          const searchString = trimWhitespace(filterFormValues.search);
          const matchesName = filterByString(operator.name, searchString);
          const matchesOperatorId = filterByString(operator.displayName, searchString);
          return matchesName || matchesOperatorId;
        })
      : operatorsList;
  },
);

export const getOperatorById = createSelector(
  [getAllOperators, (state: RootState, id: string) => id],
  (operators: Operator[], id: string): Operator | undefined => {
    return operators.find((op) => op.id === id);
  },
);
